import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './NotificationPreviewRow.html?raw';
//import DataItems = require("DataItems");
import NotificationDisplay from './NotificationDisplay';
import { NotificationTopics, NotificationTypes } from "./NotificationTypes";
import { DateHelpers, HtmlHelpers } from "../../../more/Helpers";

class NotificationPreviewRow extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private data: NotificationTypes.NotificationEntity_Base;

    protected _messageDisplay: MdsLax<InstanceType<typeof NotificationDisplay>>;

    
    private txtNotificationDate: HTMLDivElement;
    private subjectContainer: HTMLDivElement;
    private messageContainer: HTMLDivElement;
    private iconContainer: HTMLDivElement;
    private btnOpenTarget: HTMLDivElement;
    private openTargetContainer: HTMLDivElement;

    applyData(data?: NotificationTypes.NotificationEntity_Base): void {

        if (data) {
            if (!this.data || data.ID != this.data.ID) {
                if (this.data) {
                    this.removeSubscription(NotificationTopics.Updated_Single + this.data.ID);
                }
                this.addSubscription(NotificationTopics.Updated_Single + data.ID, lang.hitch(this, this._onUpdatedNotification));
            }
            this.data = data;
        }


        // zurücksetzen diverses Knoten, Buttons .... ?
        this.UiModder.domStyle.set(this.subjectContainer, "font-weight", "");

        
        
        // Daten setzen
        if (this.data == null) {
            return;
        }

        data = this.data;

        // Betreff
        this.subjectContainer.innerHTML = this.data.subject;
        this.messageContainer.innerHTML = this.data.message;

        this.txtNotificationDate.innerHTML = this.data.alert_date ? DateHelpers.dateTimeToString(this.data.alert_date) : DateHelpers.dateTimeToString(this.data.date_notification);


        this.UiModder.domClass.add(this.domNode, this.data.type);
        this.UiModder.domClass.toggle(this.domNode, "unread", this.data.is_read === false);
        this.UiModder.domClass.toggle(this.domNode, "confirmationNeeded", this.data.is_confirmation_needed === true);
        this.UiModder.domClass.toggle(this.domNode, "confirmed", this.data.is_confirmed === true);

        if (this.data.iconclass) {
            //this.hideNode(this.iconContainer, false);
            HtmlHelpers.createFontawesomeIcon(this.data.iconclass, "right", this.iconContainer, "only");
        } //else this.hideNode(this.iconContainer);
        else {
            //this.hideNode(this.iconContainer, false);
            HtmlHelpers.createFontawesomeIcon(this.data.type == "reminder" ? "fas fa-bell defaultIcon" : "fas fa-comment defaultIcon", "right", this.iconContainer, "only");
        }

        //this.hideNode(this.openTargetContainer, !this.data.ref_subject_entity);

        //// Inhalt
        //let content = messageEntry.messageData.message_content_D;
        //this.UiModder.domConstruct.create("div", { "innerHTML": content }, entryRootnode);
    }

    private _onClick_ShowMessage(evt: any): void {

        let dsp = new NotificationDisplay();
        dsp.setup(this.data);
    }

    private _onUpdatedNotification(newData: NotificationTypes.NotificationEntity_Base) {
        this.applyData(newData);
    }


    protected _setupSubscriptions(): void {
        //this._topics.push(topic.subscribe("Messages/Loaded", lang.hitch(this, this._onMessageListenerLoaded)));
    }

    private _onClick_Confirm() {
        this.data.is_confirmed = true;
        topic.publish(NotificationTopics.Updated_Single + this.data.ID, this.data);
    }
    private _onClick_Unread() {
        this.data.is_read = false;
        topic.publish(NotificationTopics.Updated_Single + this.data.ID, this.data);
    }
    private _onClick_Read() {
        this.data.is_read = true;
        topic.publish(NotificationTopics.Updated_Single + this.data.ID, this.data);
    }

    private _onClick_Target() {

    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(NotificationPreviewRow);